<script setup lang="ts">
interface IProps {
  label: string
  value?: unknown
  paddingX: number | string
  paddingY: number | string
  bold?: boolean
  borderRadius?: number | string
  textColor?: string
  textSize?: number | string
  bgColor?: string
  bgOpacity?: number | string
  opacity?: number | string
}

const props = withDefaults(defineProps<IProps>(), {
  bold: false,
  borderRadius: 0,
  textColor: 'primary',
  bgColor: 'primary',
  bgOpacity: 100,
  opacity: 100,
})

const emits = defineEmits([ 'click', 'click.stop' ])

const padding = computed(() => {
  return `${props.paddingY}px ${props.paddingX}px`
})

const borderRadius = computed(() => {
  return `${props.borderRadius}px`
})

const labelSize = computed(() => {
  return `${props.textSize}px`
})

const labelColor = computed(() => {
  return `text-${props.textColor}`
})

const backgroundColor = computed(() => {
  if (props.bgOpacity === 100) {
    return `bg-${props.bgColor}`
  }
  return `bg-${props.bgColor}/${props.bgOpacity}`
})

const opacity = computed(() => {
  return `opacity-${props.opacity}`
})
</script>

<template>
  <div
    class="badge-wrapper"
    :class="[labelColor, backgroundColor, opacity]"
    @click="emits('click', value)"
    @click.stop="emits('clickStop', value)"
  >
    <span
      class="badge"
      :class="[labelColor, bold && 'font-bold']"
    >{{ label }}</span>
  </div>
</template>

<style scoped lang="scss">
.badge-wrapper {
  @apply max-w-fit truncate;
  padding: v-bind(padding);
  border-radius: v-bind(borderRadius);

  .badge {
    @apply truncate;
    font-size: v-bind(labelSize);
  }
}
</style>